import { IMergeFile } from 'interfaces-lib';
import { IFileToPathConverter } from '../../interfaces/ifiletopathconverter';

export class SalesforceFileToPathConverter implements IFileToPathConverter {
  private readonly listType: string;

  // @TODO: work on salesforce files
  constructor(listType: string) {
    this.listType = listType;
  }

  convert(file: IMergeFile): string[] {
    return [
      file.belongsTo?.type, // Candidate
      file.belongsTo?.id, // Candidate id
      file.id, // file id
    ];
  }
}
